import { Injector, OnInit, HostListener, Directive } from "@angular/core";
import { AppComponentBase } from "./app-component-base";
import { FormControl } from "@angular/forms";

export class PagedResultDto {
  items: any[];
  totalCount: number;
}

export class EntityDto {
  id: number;
}

export class PagedRequestDto {
  skipCount: number;
  maxResultCount: number;
}

@Directive()
export abstract class PagedListingComponentBase extends AppComponentBase
  implements OnInit {
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public totalPages: number = 1;
  public totalItems: number;
  public gridSummary: string;
  public isTableLoading = false;

  // filterValue: string = "";
  filterValue= new FormControl();
  filterOption: string = ""; 

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  refreshPage() {
    this.pageNumber = 1;
    this.totalPages = 1;
  }

  refresh(): void {
    this.getData();
  }

  onPageChange(value) {
    this.pageNumber = value ? value : 1;
    this.refresh();
  }

  getFilterOption(url: string): string {
    let filter = [];
    if (
      this.filterOption == null ||
      this.filterOption == undefined ||
      this.filterOption == ""
    )
      return url;
    if (
      this.filterValue.value == null ||
      this.filterValue.value == undefined ||
      this.filterValue.value == ""
    )
      return url;
    filter.push({ Field: this.filterOption, Value: this.filterValue.value });
    return `${url}&filters=${JSON.stringify(filter)}`;
  }

  abstract getData();

  calculateTotalPages(){
    this.totalPages = Math.ceil(this.totalItems / this.pageSize); 
  }
}
